<div class="scenario-wrapper">
    <div class="image-container">
      <img src="../../assets/img/construction.png" alt="Scenario Modelling Image" />
    </div>
  </div>
  